module.exports = __webpack_public_path__ + "stylesheets/relation-list_fcee6a674e1a392f24e12648730540c0.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/relation-list.less
// module id = hVBH
// module chunks = 151